const normalizeTargetPart = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

const QUICK_ORDER_ALIASES = new Set([
  "quick",
  "quick_bill",
  "quick_order",
  "quickorder",
]);

export const isAiTargetCurrent = ({ target, currentValue, currentType }) => {
  const targetValue = normalizeTargetPart(target?.value);
  const targetType = normalizeTargetPart(target?.type);
  const normalizedCurrentValue = normalizeTargetPart(currentValue);
  const normalizedCurrentType = normalizeTargetPart(currentType);

  if (!targetValue) return true;
  if (targetValue === normalizedCurrentValue) return true;

  if (normalizedCurrentType === "quick_order") {
    return targetType === "quick_order" || QUICK_ORDER_ALIASES.has(targetValue);
  }

  return false;
};
